var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'ios': _vm.ios, 'no-ios': !_vm.ios },attrs:{"id":"app"}},[_c('Header'),(_vm.showIntro)?_c('Intro',{on:{"kill":function($event){_vm.showIntro = false}}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }